


















import { plainToInstance } from 'class-transformer'
import { Component } from 'vue-property-decorator'

import MessageEditorWithMedia from '../../../NewMessageEditors/NewMessageEditorWithMedia/MessageEditorWithMedia.vue'
import MessageEditorWithMediaData from '../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import FieldWrapper from '../../components/FieldWrapper.vue'
import { BaseInput } from '../../mixins'

@Component({
  components: {
    FieldWrapper,
    MessageEditorWithMedia,
  }
})
export default class MessageEditorWithMediaInput extends BaseInput {
  editorMessageLimit = 4096

  get editorValue() {
    if (this.value instanceof MessageEditorWithMediaData) {
      return this.value
    } else {
      return plainToInstance(MessageEditorWithMediaData, this.value)
    }
  }

  set editorValue(value: any) {
    this.value = value
  }

  downgradeCounterMax():void {
    this.editorMessageLimit = 1024
  }

  resetCounterMax():void {
    this.editorMessageLimit = 4096
  }
}
